import React, {Fragment} from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field, change, SubmissionError, submit } from 'redux-form'
import { UnoUtil, UnoCaptcha } from "uno-security-common"
import validate from '../validation/ForgetPasswordSendEmailValidation'
import { setPage } from "../actions/index"
import { withTranslation } from 'react-i18next';

const renderInput = UnoUtil.inputRenderer.renderInput;
const UnoCaptchaComponent = UnoCaptcha.UnoCaptchaComponent;
const formName = "forgetpasswordsendemailform";
const getSecurityHeaders = UnoUtil.security.getSecurityHeaders;

const SubmitHelper = {};

const mySubmitHandler = async (values) => {
    const dispatch = SubmitHelper.dispatch;
    const messages = SubmitHelper.cmeUno.messages;

    return await fetch("forgetpassword/sendResetPasswordEmail", {
        method: "POST",
        headers: {
            ...getSecurityHeaders(),
            Accept: 'application/json',
            "Content-Type": 'application/json'
        },
        body: JSON.stringify(values),
        credentials: 'same-origin'
    }).then((response) => {
        if (response.ok){
            dispatch(setPage("emailSent"));
        } else {
            dispatch(change(formName, "captchaResponse", null));
            if (response.status === 400){
                return response.json();
            } else {
                throw new SubmissionError({_error: messages['ForgetPassword.submit.systemError']});
            }
        }
    }).then(errorBody => {
        console.log(errorBody);
        if (errorBody){
            if (errorBody.errorCode === 'Illegal.Input'){
                throw new SubmissionError({
                    _error: messages['ForgetPassword.submit.captchaError']
                });
            }
        }
    });
};

class ForgetPasswordSendEmailFormImplComponent extends React.Component {

    constructor(props){
        super(props);
        const {t} = this.props
        props.cmeUno.validationData.requiredUserName =  t('forgetPasswordSendEmail.user_id_label_required')
        console.log(props.cmeUno.validationData.userName.messages.required)
        this.cmeUno = props.cmeUno;
        this.dispatch = props.dispatch;
        SubmitHelper.dispatch = this.dispatch;
        SubmitHelper.cmeUno = this.cmeUno;

        this.unoCaptchaInstanceGetter = this.unoCaptchaInstanceGetter.bind(this);
        this.unoCaptchaChangeCallback = this.unoCaptchaChangeCallback.bind(this);
        this.submitFormClick = this.submitFormClick.bind(this);
    }

    unoCaptchaInstanceGetter(unoCaptchaInstance){
        this.unoCaptchaInstance = unoCaptchaInstance;
        SubmitHelper.unoCaptchaInstance = unoCaptchaInstance;
    }

    unoCaptchaChangeCallback(){
        this.dispatch(submit(formName));
    }

    submitFormClick(e){
        e.preventDefault();
        return this.unoCaptchaInstance.execute('forget_password');
    }


    render() {
        const {
            cmeUno,
            //The three props below come from redux-form
            handleSubmit,
            pristine,
            submitting,
            valid,
            error,
            t
        } = this.props;

        const oneThirdClassName = "required grid__col-xs-12 grid__col-sm-12 grid__col-md-4 grid__col-lg-4 hard--top hard--sides soft-half--bottom"
        return (
            <Fragment>
            <h1 className="flush--bottom">
                {t('forgetPasswordSendEmail.title')}
            </h1>
            <form onSubmit={handleSubmit}>
            <p>{t('forgetPasswordSendEmail.description')}</p>
                {
                    error &&
                    <div className="alert alert--error push--top">{error}</div>
                }
                <ul className="form-fields">
                    <Field
                        name="userName"
                        id="userName"
                        required={true}
                        wrapperClassName={oneThirdClassName}
                        label= {t('forgetPasswordSendEmail.user_id_label')}
                        className="text-input responsive"
                        component={renderInput}
                        type="text"
                        autoFocus={true}
                    />
                    <li>
                        <Field
                            disableCaptcha={cmeUno.data.unoCaptcha.disableCaptcha}
                            formName={formName}
                            siteKey={cmeUno.data.unoCaptcha.siteKey}
                            jcaptchaImage={cmeUno.data.unoCaptcha.jcaptchaImage}
                            jcaptchaLabel={cmeUno.messages.captchaResponse}
                            jcaptchaRefreshLabel={cmeUno.messages.refresh}
                            id="captchaResponse"
                            name="captchaResponse"
                            component={UnoCaptchaComponent}
                            unoCaptchaRef={this.unoCaptchaInstanceGetter}
                            changeCallback={this.unoCaptchaChangeCallback}
                        />
                    </li>
                </ul>
                <div>
                    <a id="backToLogin" href="backToLogin.action" className="btn btn--secondary push--right btn--large"> {t('forgetPasswordSendEmail.btn_back_to_login')}</a>
                    <button type="submit"
                            className="btn btn--large"
                            disabled={pristine || !valid || submitting }
                            onClick={this.submitFormClick}
                    >
                        {
                            (submitting) &&
                            <span><i className="fa fa-spin fa-spinner" /> <span>{t('forgetPasswordSendEmail.txt_processing')}</span></span>
                        }
                        {! submitting && <span>{t('forgetPasswordSendEmail.btn_submit')}</span>}
                    </button>
                </div>
            </form>
            </Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    cmeUno: ownProps.cmeUno,
    state: state
});

const ForgetPasswordSendEmailFormComponent = reduxForm({
    form: formName,
    validate: validate,
    onSubmit: mySubmitHandler
})(connect(mapStateToProps)(withTranslation()(ForgetPasswordSendEmailFormImplComponent)));

export default ForgetPasswordSendEmailFormComponent;